import { SentAmestoStatus } from '../enum/sent-amesto-status';
import { Factory } from '../interface/factory';
import { PaymentSplit } from './payment/payment-split';

export class SentStatus {
  status: SentAmestoStatus;

  constructor(json: any) {
    this.status = json.status;
  }

  public static getFactory(): Factory<SentStatus> {
    return new (class implements Factory<SentStatus> {
      make(json: any): SentStatus {
        switch (json.status) {
          case SentAmestoStatus.Pending:
            return new SentAmestoPending(json);
          case SentAmestoStatus.Failed:
            return new SentAmestoFailed(json);
          case SentAmestoStatus.PartiallySucceeded:
            return new SentAmestoPartiallySucceeded(json);
          case SentAmestoStatus.Succeeded:
            return new SentAmestoSucceeded(json);
          default:
            throw new Error(`Unrecognized SentAmesto status (${json.status}).`);
        }
      }
      getTableName(): string {
        throw new Error('SentAmesto is never stored in IndexedDB.');
      }
    })();
  }
}

export class SentAmestoPending extends SentStatus {
  constructor(json: any) {
    super(json);
  }
}

export class SentAmestoFailed extends SentStatus {
  firstAttempt: Date;

  constructor(json: any) {
    super(json);
    this.firstAttempt = new Date(json.firstAttempt);
  }
}

export class SentAmestoPartiallySucceeded extends SentStatus {
  remaining: PaymentSplit[];
  firstAttempt: Date;

  constructor(json: any) {
    super(json);
    this.remaining = json.remaining ? json.remaining.map((split: any) => new PaymentSplit(split)) : [];
    this.firstAttempt = new Date(json.firstAttempt);
  }
}

export class SentAmestoSucceeded extends SentStatus {
  firstAttempt?: Date;
  finalAttempt: Date;

  constructor(json: any) {
    super(json);
    this.firstAttempt = json.firstAttempt ? new Date(json.firstAttempt) : undefined;
    this.finalAttempt = new Date(json.finalAttempt);
  }
}
